
import { dataFix } from "../../common/dataFix";
import { createRefPath } from "../appData/appRefPaths";
import { createFsDocKey } from "../appData/fsAppData";

/**
 * add the `dataItems` to a `collection`
 * @param {*} refPath 
 * @param {*} vit 
 * @param {*} directCollection 
 * @param {*} dataItems 
 * @param {*} useAutoKey 
 * @returns Promise.all(promises)
 * @description Creates an array of add_ref promises 
 */
export const addPromise = (database_fns, refPath, vit, directCollection, dataItems, useAdd, useAutoKey) => {
  const promises = []
  Object.keys(dataItems).forEach(itemKey => {
    if (itemKey) {
      try {
        const item = dataItems[itemKey]
        dataFix.deleteObjectItems(item, ['uid', 'id', 'key', '_itemKey', 'checked'])
        dataFix.deleteUTCs(item)
        const coll = directCollection ? directCollection : vit
        if (useAdd) {
          let _addPath = createRefPath([coll], refPath)
          const r = database_fns.doc_add(_addPath, item)
          promises.push(r)
        } else {
          let _setPath = createRefPath([coll, useAutoKey ? database_fns.get_docKey() : itemKey], refPath)
          const r = database_fns.doc_set(_setPath, item)
          promises.push(r)
        }
      } catch (error) {
        console.error('addPromise', error)
      }
    }
  })
  return Promise.all(promises)
}